module.exports = __webpack_public_path__ + "static/img/nugraha.a008597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/nugraha.jpg
// module id = 8uuW
// module chunks = 1